import { render } from "./AgilesSolutions.vue?vue&type=template&id=1318d79e&scoped=true"
import script from "./AgilesSolutions.vue?vue&type=script&lang=js"
export * from "./AgilesSolutions.vue?vue&type=script&lang=js"

import "./AgilesSolutions.vue?vue&type=style&index=0&id=1318d79e&scoped=true&lang=css"

import exportComponent from "C:\\AT\\Sites\\agiles_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1318d79e"]])

export default __exports__